export default "__VITE_ASSET__bec04e00__"